import { useInstalledPlatformAppsQuery } from './useInstalledPlatformAppsQuery';
export const useInstalledPlatformApps = ({ enabled }) => {
    const { installedPlatformAppsQuery } = useInstalledPlatformAppsQuery([], {
        enabled,
    });
    return {
        installedPlatformApps: installedPlatformAppsQuery.data,
        isLoading: installedPlatformAppsQuery.isLoading,
    };
};
